"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bit_javascript_raw_code_generator_1 = require("@bit/bit.javascript.raw.code-generator");

var bit_javascript_default_generator_canonize_1 = require("@bit/bit.javascript.default-generator.canonize");

var codeGenerator = new bit_javascript_raw_code_generator_1.CodeGenerator();
exports.mainFile = 'index.tsx';

function makeReactNativeTemplate(_a) {
  var _b;

  var npmId = _a.npmId;
  var code = genrateMainFile(npmId);
  return {
    files: (_b = {}, _b[exports.mainFile] = code, _b),
    mainFile: exports.mainFile
  };
}

exports.makeReactNativeTemplate = makeReactNativeTemplate;

function genrateMainFile(npmId) {
  var defaultName = bit_javascript_default_generator_canonize_1.toCanonicalClassName(npmId);
  var moduleId = bit_javascript_default_generator_canonize_1.canonizeNpmId(npmId);
  return [codeGenerator.generateImport({
    defaultName: 'React',
    moduleId: 'react'
  }), codeGenerator.generateImport({
    nonDefaults: ['StyleSheet', 'View', 'Text'],
    moduleId: 'react-native'
  }), codeGenerator.generateImport({
    defaultName: defaultName,
    moduleId: moduleId
  }), '', "const styles = StyleSheet.create({", "\tcontainer: { flex: 1 }, //etc", "});", '', "export default () => (", "\t<View style={styles.container}>", "\t\t<" + defaultName + "/>", "\t</View>", ")"].join('\n');
}